import onIntersectionObserve from '@/helpers/on_intersection_observe';

let leadFormApp = null;

$(document).on('turbolinks:before-cache', () => {
  if (leadFormApp) {
    leadFormApp.unmount();
    leadFormApp = null;
  }
});

$(document).on('turbolinks:load', () => {
  const node = document.querySelector('article.v4.franchise_lead_form #franchise_lead_form');
  if (!node) { return; }

  onIntersectionObserve(node, async mountNode => {
    const { createApp, h } = await import(/* webpackChunkName: "vue" */ 'vue');
    const { default: Component } = await import('@/vue/franchise/lead_form');

    const $node = $(mountNode);

    leadFormApp = createApp({
      setup: () => () => h(Component, {
        submitUrl: $node.data('submit_url'),
        leadType: $node.data('leadType'),
        trackEvent: $node.data('trackEvent'),
        trackEventLocation: $node.data('trackEventLocation'),
        privacyUrl: $node.data('privacy_url'),
        faqUrl: $node.data('faq_url'),
        graphqlUrl: $node.data('graphql_url')
      })
    });
    leadFormApp.mount(mountNode);
  });
});
